import React from 'react'
import every from 'lodash/every'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import {
  selectDaysOnMarketMean,
  selectInventoryTotal,
  selectCurrentQuartilePriceMin,
  selectCurrentQuartilePriceMax
} from 'src/store/selectors/marketRecord'
import { If, Format } from 'src/Components'
import SectionWrapper from 'src/Components/shared/SectionWrapper'

import baseStyles from './MarketSpotlight.module.scss'

const MarketOverview = () => {
  const daysOnMarketMean = Math.round(useSelector(selectDaysOnMarketMean) || 0)
  const availableHomes = Math.round(useSelector(selectInventoryTotal) || 0)
  const priceRangeMin = useSelector(selectCurrentQuartilePriceMin) || 0
  const priceRangeMax = useSelector(selectCurrentQuartilePriceMax) || 0

  return (
    <If
      condition={
        every(
          [daysOnMarketMean, priceRangeMin, priceRangeMax],
          val => val > 0
        ) && availableHomes > 1
      }
    >
      <SectionWrapper
        data-qa='market-overview-section'
        className={baseStyles.section}
      >
        <FormattedMessage
          id='MarketSpotlight.marketOverview'
          defaultMessage='There are {availableHomes} on the market between {priceRangeMin}-{priceRangeMax} that are selling in around {daysOnMarket}'
          values={{
            availableHomes: <em>{availableHomes} homes</em>,
            daysOnMarket: (
              <em>
                {daysOnMarketMean} {daysOnMarketMean > 1 ? 'days' : 'day'}
              </em>
            ),
            priceRangeMax: <Format.Currency value={priceRangeMax} abbreviate />,
            priceRangeMin: <Format.Currency value={priceRangeMin} abbreviate />
          }}
        />
      </SectionWrapper>
    </If>
  )
}

export default MarketOverview
